module.exports = __webpack_public_path__ + "static/media/42x40-9.84ddb13c.png";